@if (loadingPage) {
  <app-loading [fullscreen]="true" label="Cargando cuentas bancarias..."></app-loading>
} @else {
  <app-page-header title="Cuentas Bancarias" description="Resumen de saldos y últimos movimientos">
    <div class="page-actions">
      <app-button
        type="button"
        [variant]="'primary'"
        [disabled]="loadingPage || loadingMovements || !banks.length"
        (clicked)="loadRecentMovements()"
      >
        <i
          class="fa-solid"
          [class.fa-spinner]="loadingMovements"
          [class.fa-spin]="loadingMovements"
          [class.fa-list-check]="!loadingMovements"
        ></i>
        {{ loadingMovements ? 'Cargando movimientos...' : 'Cargar últimos movimientos' }}
      </app-button>
    </div>
  </app-page-header>
  @if (movementError) {
    <div class="movement-error">{{ movementError }}</div>
  }
  <section class="summary-grid" aria-label="Resumen financiero">
    <app-summary-card
      label="Total disponible"
      [value]="(totalAvailable | currency: 'USD' : 'symbol' : '1.2-2') ?? ''"
      [description]="banks.length + ' cuentas activas'"
    />
    <app-summary-card
      label="Total contable"
      [value]="(totalAccounting | currency: 'USD' : 'symbol' : '1.2-2') ?? ''"
      description="Incluye pendientes"
      tone="neutral"
    />
    <app-summary-card
      label="En tránsito"
      [value]="(inTransit | currency: 'USD' : 'symbol' : '1.2-2') ?? ''"
      description="Diferencia contable"
      tone="warning"
    />
  </section>
  <section class="banks-grid" aria-label="Cuentas bancarias">
    @for (bank of banks; track bank.id) {
      <article class="bank-card">
        <div class="bank-header">
          <div class="bank-logo" [class]="bank.logoClass">{{ bank.logo }}</div>
          <div class="bank-info">
            <strong>{{ bank.name }}</strong>
            <span>{{ bank.account }}</span>
            <small>{{
              bank.lastUpdate
                ? 'Actualizada ' + (bank.lastUpdate | date: 'dd/MM/yyyy HH:mm')
                : 'Sin actualización'
            }}</small>
          </div>
        </div>
        <div class="integration-status" [class]="bank.integrationStatus ?? 'unknown'">
          <span class="status-dot"></span>
          {{ integrationStatusLabel(bank.integrationStatus) }}
        </div>
        @if (bank.integrationStatus === 'missing') {
          <a class="integration-callout" routerLink="/empresa/configuracion-bancaria">
            <i class="fa-solid fa-plug-circle-exclamation"></i>
            Configura una integración para sincronizar esta cuenta
          </a>
        }
        <div class="balances">
          @if (bank.bankCode !== 'INTERNACIONAL') {
            <div>
              <span>Disponible:</span
              ><strong class="available">{{
                bank.available | currency: 'USD' : 'symbol' : '1.2-2'
              }}</strong>
            </div>
          }
          <div class="balance-divider"></div>
          <div>
            <span>Contable:</span
            ><strong>{{ bank.accounting | currency: 'USD' : 'symbol' : '1.2-2' }}</strong>
          </div>
          @if (bank.accountingBalanceDate) {
            <small class="balance-status">
              Saldo al {{ bank.accountingBalanceDate | date: 'dd/MM/yyyy' }}
            </small>
          }
        </div>
        <div class="movements-header">
          <span>Movimientos</span>

          <app-select
            [options]="limitOptions"
            [value]="movementLimit(bank.id).toString()"
            (valueChange)="setMovementLimit(bank.id, $event)"
            [clearable]="false"
            aria-label="Número de movimientos a mostrar"
          ></app-select>
        </div>
        @if (loadingMovements) {
          <div class="movement-empty">Cargando movimientos recientes...</div>
        } @else if (!movementsLoaded) {
          <div class="movement-empty">Usa el botón para cargar los últimos 7 días</div>
        } @else {
          <div class="movement-list">
            @for (movement of bank.movements | slice: 0 : movementLimit(bank.id); track $index) {
              <div class="movement-item">
                <span
                  class="movement-sign"
                  [class.credit]="movement.type === 'credit'"
                  [class.debit]="movement.type === 'debit'"
                  >{{ movement.type === 'credit' ? '+' : '−' }}</span
                ><span class="movement-description">{{ movement.description }}</span
                ><strong
                  [class.credit]="movement.type === 'credit'"
                  [class.debit]="movement.type === 'debit'"
                  >{{ movement.type === 'credit' ? '+' : '−'
                  }}{{
                    displayAmount(movement.amount) | currency: 'USD' : 'symbol' : '1.2-2'
                  }}</strong
                >
              </div>
            } @empty {
              <div class="movement-empty">No hay movimientos recientes</div>
            }
          </div>
        }
      </article>
    }
  </section>
}
